
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1707"}},[_c('path',{attrs:{"data-name":"Rectangle 2410","fill":"none","d":"M0 0h25v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1706","fill":"#3c3c3c"}},[_c('path',{attrs:{"data-name":"Path 1057","d":"M12.844 1.5a1.5 1.5 0 00-3 0A1.922 1.922 0 116 1.5a1.5 1.5 0 00-3 0 4.911 4.911 0 003.422 4.664v7.67A4.912 4.912 0 003 18.497a1.5 1.5 0 003 0 1.922 1.922 0 013.844 0 1.5 1.5 0 003 0 4.913 4.913 0 00-3.422-4.663v-7.67A4.912 4.912 0 0012.844 1.5z"}}),_c('path',{attrs:{"data-name":"Path 1058","d":"M21 11.092V1.5a1.5 1.5 0 00-3 0v9.592a1.5 1.5 0 00-1 1.408v6a1.5 1.5 0 001.5 1.5h2a1.5 1.5 0 001.5-1.5v-6a1.5 1.5 0 00-1-1.408z"}})])])])
          )
        }
      }
    